export default __webpack_public_path__ + "static/media/doc-filter-ax.50aaf452.svg";